import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  isOwnerMissing: boolean;
  params: any;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  isOwnerMissing: false,
  params: {}
};

export const propertyCreateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_PROPERTY_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        isOwnerMissing: false
      };

    case Constants.PAGE_PROPERTY_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isOwnerMissing: false
      };

    case Constants.PAGE_PROPERTY_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR:
    case Constants.PAGE_PROPERTY_CREATE_CLEAR:
    case Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR:
      return {
        ...initialState
      };


    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_PROPERTY_CREATE_ADD_PARAMS:
      return {
        ...state,
        params: action.payload
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
